import React, { useState } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
    Button,
    CircularProgress,
    Grid,
    TextField,
    Typography,    
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AttachFile } from "@material-ui/icons";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    mainHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    mainHeaderButtonsWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 500,
    },
    mainPaper: {
        flex: 1,
        padding: theme.spacing(3),
        paddingBottom: 100,
        height: 'calc(100vh - 10vh)',
        width: '100vw',
        maxWidth: '100%',
        boxSizing: 'border-box',
        
        overflowY: "auto",
        ...theme.scrollbarStyles,
    },
    formContainer: {
        maxWidth: 600,
        margin: "0 auto",
    },
    textRight: {
        textAlign: "right",
    },
    tabContent: {
        marginTop: theme.spacing(2),
    },
    input: {
        display: "none",
    },
    fileLabel: {
        marginTop: theme.spacing(1),
    },
    searchField: {
        marginRight: theme.spacing(2),
    },
}));

const MessagesAPI = () => {
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);
    const [file, setFile] = useState(null);
    const [searchParam, setSearchParam] = useState("");

    const formMessageTextData = { token: "", number: "", body: "" };
    const formMessageMediaData = { token: "", number: "" };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleSendTextMessage = async (values) => {
        try {
            const { number, body } = values;
            const data = { number, body };
            const options = {
                method: "POST",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/messages/send`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${values.token}`,
                },
                data,
            };

            await axios.request(options);
            toast.success("Mensagem de texto enviada com sucesso");
        } catch (error) {
            toastError(error);
        }
    };

    const handleSendMediaMessage = async (values) => {
        try {
            if (!file) {
                toastError("Por favor, selecione um arquivo.");
                return;
            }

            const data = new FormData();
            data.append("number", values.number);
            data.append("body", file.name);
            data.append("medias", file);

            const options = {
                method: "POST",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/messages/send`,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${values.token}`,
                },
                data,
            };

            await axios.request(options);
            toast.success("Mensagem de mídia enviada com sucesso");
            setFile(null); // Limpa o estado do arquivo após o envio
        } catch (error) {
            toastError(error);
        }
    };

    const handleSearch = (event) => {
        setSearchParam(event.target.value.toLowerCase());
    };

    const renderFormMessageText = () => (
        <Formik
            initialValues={formMessageTextData}
            onSubmit={async (values, actions) => {
                await handleSendTextMessage(values);
                actions.setSubmitting(false);
                actions.resetForm();
            }}
        >
            {({ isSubmitting }) => (
                <Form className={classes.formContainer}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Field
                                as={TextField}
                                label="Token"
                                name="token"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                as={TextField}
                                label="Número (com DDD e código do país)"
                                name="number"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                as={TextField}
                                label="Mensagem"
                                name="body"
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={4}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.textRight}>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    "Enviar Mensagem de Texto"
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );

    const renderFormMessageMedia = () => (
        <Formik
            initialValues={formMessageMediaData}
            onSubmit={async (values, actions) => {
                await handleSendMediaMessage(values);
                actions.setSubmitting(false);
                actions.resetForm();
            }}
        >
            {({ isSubmitting }) => (
                <Form className={classes.formContainer}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Field
                                as={TextField}
                                label="Token"
                                name="token"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                as={TextField}
                                label="Número (com DDD e código do país)"
                                name="number"
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <input
                                accept="image/*,video/*,audio/*,.pdf,.doc,.docx"
                                className={classes.input}
                                id="contained-button-file"
                                type="file"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                            <label htmlFor="contained-button-file" className={classes.fileLabel}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<AttachFile />}
                                >
                                    Selecionar Arquivo
                                </Button>
                                {file && <Typography variant="body2">{file.name}</Typography>}
                            </label>
                        </Grid>
                        <Grid item xs={12} className={classes.textRight}>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={isSubmitting || !file}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    "Enviar Mensagem de Mídia"
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );

    return (
        <MainContainer className={classes.mainContainer}>
            <MainHeader>
                <Title>Integração para envio de mensagens</Title>
            </MainHeader>
            <Paper className={classes.mainPaper} variant="outlined">
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Mensagem de Texto" />
                    <Tab label="Mensagem de Mídia" />
                </Tabs>

                <div className={classes.tabContent}>
                    {tabValue === 0 && renderFormMessageText()}
                    {tabValue === 1 && renderFormMessageMedia()}
                </div>
            </Paper>
        </MainContainer>
    );
};

export default MessagesAPI;
